<template>
    <div id="mapdiv" class="map-wrapper">
        <div v-if="preview_enabled" class="preview-map">
            <img v-if="preview_image" :src="preview_image" class="preview-image" :alt="company_details.name">
            <modal-trigger
                :modal_name="'restaurant-map'"
                :holder_classes="'cursor-pointer'">
                <button type="button" class="btn btn-primary btn-open--map">{{ show_map_text }}</button>
            </modal-trigger>
        </div>
        <iframe v-else
                style="border: 0;"
                loading="lazy"
                allowfullscreen
                :src="'https://www.google.com/maps/embed/v1/place?key=' + api_key + '&q=' + company_details.address + '&center=' + company_details.lat + ',' + company_details.lng + '&zoom=16'">
        </iframe>
    </div>
</template>

<script>
import mixins from "../mixins";

export default {
    mixins: [
        mixins
    ],
    props: {
        show_map_text: {
            type: String,
            default: 'Show map'
        },
        preview_image: {
            type: String,
            required: true
        },
        details: {
            type: String,
            required: true
        },
        get_route: {
            type: String,
            required: true
        },
        api_key: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            company_details: {},
            preview_enabled: true,
        }
    },
    mounted() {
        this.company_details = JSON.parse(this.details);
    }
}
</script>

<style>
.map-wrapper {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: visible;
}

.preview-map {
    width: 100%;
    height: 100%;
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(1px);
}

.btn-open--map {
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.H_ib_content {
    width: 300px;
    font-size: 12px;
    margin: 0;
    padding: 2px 10px;
}

.H_ib_body {
    margin-right: -17em;
    margin-bottom: 68px;
}

.H_ib_tail::after {
    bottom: 63px;
}

.H_ib_tail::before {
    bottom: 63px;
}

@media (min-width: 320px) and (max-width: 480px) {
    .H_ib_content {
        width: 200px !important;
    }

    .H_ib_body {
        margin-right: -12em !important;
    }
}

@media (max-width: 768px) {
    .map-wrapper {
        height: 200px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/FlatMap.vue